import React from "react";
import { Box, Divider, Icon, IconButton, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import {
  AddRounded,
  RemoveRounded,
  FullscreenRounded,
  ClearRounded,
} from "@mui/icons-material";

const useStyles = makeStyles()((theme) => ({
  container: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.default,
    boxShadow: "0px 0px 20px 3px rgba(57, 41, 113, 0.14)",
    position: "absolute",
    bottom: 4,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 999,
    display: "flex",
    alignItems: "center",
    padding: 4,
  },
  iconButton: {
    color: theme.palette.text.primary,
  },
}));

function ZoomPanel({
  isolationMarkup,
  scale,
  onZoomIn,
  onZoomOut,
  onReset,
  onIsolationMarkupChange,
}) {
  const { classes } = useStyles();

  const getDisplayScale = (rawScale) => {
    const relativeScale = rawScale / 0.7;
    return `${relativeScale.toFixed(1)}x`;
  };

  return (
    <Box className={classes.container}>
      <IconButton className={classes.iconButton} onClick={() => onZoomOut()}>
        <RemoveRounded />
      </IconButton>
      <Typography variant="body2" mx={1}>
        {getDisplayScale(scale)}
      </Typography>
      <IconButton className={classes.iconButton} onClick={() => onZoomIn()}>
        <AddRounded />
      </IconButton>
      <IconButton className={classes.iconButton} onClick={() => onReset()}>
        <FullscreenRounded />
      </IconButton>
      {isolationMarkup && (
        <IconButton
          className={classes.iconButton}
          onClick={() => onIsolationMarkupChange(null)}>
          <ClearRounded />
        </IconButton>
      )}
    </Box>
  );
}

export default ZoomPanel;
